import React from 'react';

const DANGER_LEVEL = 100 - 12; // %
const WARNING_LEVEL = DANGER_LEVEL - 24; // %

interface AWVuMeterArgonProps extends React.HTMLAttributes<HTMLDivElement> {
  max?: number;
  min?: number;
  steps?: number;
  peakValue: number;
  decayValue?: number;
  horizontal?: boolean;
  disabled?: boolean;
}

export const AWVuMeterArgon: React.FC<AWVuMeterArgonProps> = ({
  horizontal = false,
  max = 100,
  min = 0,
  steps = 7,
  peakValue,
  decayValue,
  disabled,
  ...otherProps
}) => {
  const total = Math.abs(max - min);
  const heightPercentage = max / steps;
  const peakPercentage = Math.abs(peakValue - min) / total;
  const peakIndex = Math.abs(peakPercentage * steps);
  const decayIndex = decayValue ? Math.round(Math.abs((Math.abs(decayValue - min) / total) * steps)) : null;

  return (
    <div
      {...otherProps}
      className={`vu-meter-argon${horizontal ? ' horizontal' : ''}${disabled ? ' disabled' : ''}${
        horizontal ? ` horizontal` : ''
      }`}
    >
      <>
        {Array.from({ length: steps }).map((_, index) => {
          const indexPercentage = (index / steps) * 100;
          return (
            <div
              key={index}
              className={`${
                peakIndex >= index
                  ? indexPercentage > DANGER_LEVEL || index === steps - 1
                    ? 'danger'
                    : indexPercentage > WARNING_LEVEL || index === steps - 2
                    ? 'warning'
                    : 'active'
                  : ''
              }${decayIndex === index ? ' decay' : ''}`}
              style={{ [horizontal ? 'width' : 'height']: `${heightPercentage}%` }}
            ></div>
          );
        })}
      </>
    </div>
  );
};

interface AWVuMeterArgonWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  horizontal?: boolean;
  transparent?: boolean;
}

export const AWVuMeterArgonWrapper: React.FC<AWVuMeterArgonWrapperProps> = ({
  horizontal,
  transparent,
  children,
  className,
  ...otherProps
}) => {
  return (
    <div
      className={`vu-meter-argon-wrapper${className ? ` ${className}` : ''}${horizontal ? ` horizontal` : ''}${
        transparent ? ` transparent` : ''
      }`}
      {...otherProps}
    >
      {children}
    </div>
  );
};
